import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_DATALIMIT = 'GET_DATALIMIT';

export const actions = createSagaActionTypes('DATA_LIMIT_STATS', [
  GET_DATALIMIT
]);
